<!--
 * @Author: wangwei
 * @Date: 2020-12-29 16:05:36
 * @LastEditTime: 2021-01-09 17:26:39
 * @LastEditors: Please set LastEditors
 * @Description: 账号安全
 * @FilePath: /java-pc/src/views/member/center/Account.vue
-->
<template>
    <div class="sld_account">
        <MemberTitle :memberTitle="L['账号安全']"></MemberTitle>
        <div class="container">
            <div class="title">{{L['账号安全']}}</div>
            <div class="commonContent">
                <div class="item flex_row_start_center">
                    <i :class="{iconfont:true, 'icon-jubao':!memberInfo.data.memberMobile, 'icon-xuanweimorendizhi':memberInfo.data.memberMobile}"></i>
                    <div class="item_info flex_row_start_center">
                        <span>Phone Number</span>
                        <span class="tips" v-if="memberInfo.data.memberMobile">Bound Phone: {{memberInfo.data.memberMobile}}, if the phone is lost or deactivated, please update promptly</span>
                        <span class="no tips" v-else>Not yet bound a phone number</span>
                        <div>
                            <span class="oprate pointer" v-if="memberInfo.data.memberMobile"
                                  @click="toPage('/member/phone','edit')">Change Phone</span>
                            <span class="oprate pointer" @click="toPage('/member/phone','bind')"
                                  v-else>Bind Phone</span>
                        </div>
                    </div>
                </div>
                <div class="item flex_row_start_center">
                    <i :class="{iconfont:true, 'icon-jubao':!memberInfo.data.memberEmail, 'icon-xuanweimorendizhi':memberInfo.data.memberEmail}"></i>
                    <div class="item_info flex_row_start_center">
                        <span>Email</span>
                        <span class="tips" v-if="memberInfo.data.memberEmail">Bound Email: {{memberInfo.data.memberEmail}}, if the email is deactivated, please update promptly</span>
                        <span class="no tips" v-else>Not yet bound an email</span>
                        <div>
                            <span class="oprate pointer" @click="toPage('/member/email','edit')"
                                  v-if="memberInfo.data.memberEmail">Change Email</span>
                            <span class="oprate pointer" @click="toPage('/member/email','bind')"
                                  v-else>Bind Email</span>
                        </div>
                    </div>
                </div>
                <div class="item flex_row_start_center">
                    <i :class="{iconfont:true, 'icon-jubao':!memberInfo.data.hasLoginPassword, 'icon-xuanweimorendizhi':memberInfo.data.hasLoginPassword}"></i>
                    <div class="item_info flex_row_start_center">
                        <span>Login Password</span>
                        <span class="tips">A strong password protects your account. We recommend 6-20 characters with letters, numbers, and symbols</span>
                        <div>
                            <span class="oprate pointer" @click="toPage('/member/pwd/login','edit')"
                                  v-if="memberInfo.data.hasLoginPassword">Change Password</span>
                            <span class="oprate pointer" @click="toPage('/member/pwd/login','set')" v-else>Set Password</span>
                        </div>
                    </div>
                </div>
                <div class="item flex_row_start_center">
                    <i :class="{iconfont:true, 'icon-jubao':!memberInfo.data.hasPayPassword, 'icon-xuanweimorendizhi':memberInfo.data.hasPayPassword}"></i>
                    <div class="item_info flex_row_start_center">
                        <span>Payment Password</span>
                        <span class="tips">A payment password is required when using account balance to protect your funds</span>
                        <div class="flex_column_center_center">
                            <span class="oprate pointer" @click="toPage('/member/pwd/pay','edit')"
                                  v-if="memberInfo.data.hasPayPassword">Change Password</span>
                            <span class="oprate pointer" @click="toPage('/member/pwd/pay','set')"
                                  v-if="!memberInfo.data.hasPayPassword">Set Password</span>
                            <span class="oprate reset pointer" @click="toPage('/member/pwd/reset','reset')"
                                  v-if="memberInfo.data.hasPayPassword">Reset Password</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCurrentInstance, reactive} from "vue";
    import {useStore} from "vuex";
    import {useRouter} from "vue-router"; //引入路由
    import MemberTitle from '../../../components/MemberTitle'
    export default {
        name: "Account",
        components: {
            MemberTitle
        },
        setup() {
            const {proxy} = getCurrentInstance();
            const router = useRouter()
            const L = proxy.$getCurLanguage();
            const store = useStore();
            const memberInfo = reactive({data: store.state.memberInfo});
            const toPage = (url, type) => {
                router.push({
                    path: url,
                    query: {
                        type
                    }
                })
            }

            return {
                L,
                memberInfo,
                toPage
            };
        }
    };
</script>

<style lang="scss">
    .sld_account {
        width: 1007px;
        float: left;
        margin-left: 10px;

        .container {
            background-color: white;
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #eaeaea;
            padding: 25px 40px;

            .title {
                font-size: 18px;
                border-bottom: 1px dashed #eaeaea;
                padding-bottom: 25px;
                font-weight: 600;
            }

            .commonContent {
                margin: 35px 0;
                font-size: 14px;

                .item {
                    width: 100%;
                    border-bottom: 1px dashed #eaeaea;
                    box-sizing: border-box;
                    padding: 30px 0;

                    .item_info {
                        flex: 1;
                        min-width: 0;
                        flex-wrap: wrap;
                    }

                    .item_info > span:first-child {
                        min-width: 100px;
                        white-space: nowrap;
                    }

                    .iconfont {
                        margin-right: 10px;
                    }

                    .icon-jubao {
                        color: $colorMain2;
                    }

                    .icon-xuanweimorendizhi {
                        color: green;
                    }

                    .tips {
                        margin-left: 60px;
                        color: #999;
                        flex: 1;
                        min-width: 0;
                    }

                    .item_info > div {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        min-width: 130px;
                    }

                    .oprate {
                        color: #69c;
                        margin-left: 20px;
                        white-space: nowrap;
                    }

                    .reset {
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>
